module.exports = __webpack_public_path__ + "img/esg.69d97fb3.svg";